import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Licence reconciliation (Pax8, Microsoft Partner Center, CSV). Owned by the licences module (D10).
export const routes: RouteObject[] = [
  { path: 'licences', lazy: page(() => import('./overview-page'), (m) => m.LicencesPage) },
  { path: 'licences/connections/:connectionId/:tab?', lazy: page(() => import('./connection-page'), (m) => m.ConnectionPage) },
  { path: 'licences/runs/:runId', lazy: page(() => import('./run-page'), (m) => m.RunPage) },
];

export const orgRoutes: RouteObject[] = [];
